import { createApp } from 'vue';
import AudioToTxtConverter from '@/Components/AudioToTxtConverter.vue';
import '@styles/app.css';

createApp(AudioToTxtConverter).mount('#audio-to-text-converter');
